<template>
    <header class="l-header">
        <div class="l-header__inner">
        <div class="l-header__logo">
            <a href="/"><img src="@/assets/img/header/logo.png" alt="hubsynch"></a>
        </div>

        <div class="l-header__ui">
            <div v-if="visibleSideMenu" id="nav-sidemenu" class="head-ui-btn">
                <a href="#" aria-label="side-menu">
                    <div class="btn"><span></span><span></span><span></span></div>
                </a>
            </div>

            <div id="nav-mypage" class="head-ui-btn is-hide">
            <a href="#" aria-label="mypage-menu">
                <div class="icon"></div>
            </a>
            </div>
        </div>
        </div>
    </header>
</template>

<script setup>
const props = defineProps({
    visibleSideMenu: {
        type: Boolean,
        default: true
    }
})
</script>